/*
 * Purpose: Load Stripe Pricing Table embed script once per session
 * Last modified: 2026-06-28 | Agent
 * Completeness: 95
 */

const STRIPE_PRICING_SCRIPT = 'https://js.stripe.com/v3/pricing-table.js';

let loadPromise: Promise<void> | null = null;

export function resetStripePricingTableScript(): void {
  loadPromise = null;
}

export function loadStripePricingTableScript(): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve();

  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${STRIPE_PRICING_SCRIPT}"]`);
    if (existing) {
      if (existing.getAttribute('data-loaded') === '1') {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => {
        loadPromise = null;
        reject(new Error('Stripe pricing table script failed'));
      }, {
        once: true,
      });
      return;
    }

    const script = document.createElement('script');
    script.src = STRIPE_PRICING_SCRIPT;
    script.async = true;
    script.onload = () => {
      script.setAttribute('data-loaded', '1');
      resolve();
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Stripe pricing table script failed to load'));
    };
    document.body.appendChild(script);
  });

  return loadPromise;
}
